module.exports = __webpack_public_path__ + "static/img/jchb1-4.d45bdf1.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/jchb1-4.png
// module id = 762
// module chunks = 0